export function resolveMaxSelectable(
  maxSelectable?: number,
): number | undefined {
  if (maxSelectable === undefined) return undefined;
  if (maxSelectable <= 0) return undefined;
  return maxSelectable;
}

export function computeSelectAllChecked(
  allValues: string[],
  selectedValues: string[],
): boolean | 'indeterminate' {
  if (allValues.length === 0) return false;

  const selectedSet = new Set(selectedValues);
  const selectedInOptions = allValues.filter((value) => selectedSet.has(value));
  if (selectedInOptions.length === 0) return false;
  if (selectedInOptions.length === allValues.length) return true;
  return 'indeterminate';
}

export function toggleMultiSelectValue(
  selectedValues: string[],
  value: string,
  limit?: number,
): { next: string[]; rejected: boolean } {
  const selectedSet = new Set(selectedValues);
  if (selectedSet.has(value)) {
    return {
      next: selectedValues.filter((v) => v !== value),
      rejected: false,
    };
  }
  if (limit !== undefined && selectedValues.length >= limit) {
    return { next: selectedValues, rejected: true };
  }
  return { next: [...selectedValues, value], rejected: false };
}

export function toggleSelectAllValues(
  allValues: string[],
  selectedValues: string[],
  limit?: number,
): string[] {
  const allSelected =
    allValues.length > 0 && allValues.every((v) => selectedValues.includes(v));
  if (allSelected) return [];
  if (limit !== undefined && allValues.length > limit) {
    return allValues.slice(0, limit);
  }
  return [...allValues];
}

export function buildTriggerText(
  options: { value: string; label: string }[],
  selectedValues: string[],
  tagDisplay: 'inline' | 'count' | 'list',
  placeholder: string,
): string {
  if (selectedValues.length === 0) return placeholder;
  const labelByValue = new Map(options.map((o) => [o.value, o.label]));
  if (tagDisplay === 'count') {
    return `${selectedValues.length} selected`;
  }
  if (tagDisplay === 'list') {
    return selectedValues.map((v) => labelByValue.get(v) ?? v).join(', ');
  }
  return placeholder;
}

/** Closed one-line trigger: the field label, plus `(n)` once something is picked. */
export function buildOneLineTriggerText(
  fieldLabel: string,
  selectedCount: number,
  placeholder: string,
): string {
  const label = fieldLabel.trim() || placeholder;
  if (selectedCount <= 0) return label;
  return `${label} (${selectedCount})`;
}
